import React, {Component} from 'react'
import {
    Route,
    Redirect
} from "react-router-dom";
import Dashboard from "./dashboard/FluidDashboard";
import PermissionDenied from './PermissionDenied'
import Project from "./Project";
import AuthRoute from "./HOC/AuthRoute";
import Navigation from './Navigation'
import Projects from "./project/Projects";
import Client from './client/Client'
import Clients from "./client/Clients";
import FeeDrawdownTable from "./reports/FeeDrawdownTable";
import FeeDrawdownProjectDetail from "./reports/FeeDrawdownProjectDetailNew";
import OfficeHoursReport from "./reports/OfficeHoursReport";
import ProjectsTable from "./reports/ProjectsTable";
import ProjectAnalyticsContainer from "./reports/ProjectAnalyticsContainer";
import Timesheet from "./timesheet/Timesheet";
import Users from "./users/Users";
import User from "./users/User";
import CreateUser from "./users/CreateUser";
import AddressTypes from "./address_types/AddressTypes";
import ClientTypes from "./client_types/ClientTypes";
import ProjectActivities from "./project_activities/ProjectActivities";
import ProjectDisciplines from "./project_disciplines/ProjectDisciplines";
import ProjectStatuses from "./project_statuses/ProjectStatuses";
import ProjectFeeTypes from "./project_fee_types/ProjectFeeTypes";
import ProjectLandUses from "./project_land_uses/ProjectLandUses";
import UnbillableTypes from "./unbillable_types/UnbillableTypes";
import ContactMediums from "./contact_mediums/ContactMediums";
import StaffResource from "./staff_resource/StaffResource";
import ProjectContractStatuses from "./project_contract_statuses/ProjectContractStatuses";
import UserRolesNew from "./user_roles/UserRolesNew";
import UserRole from "./user_role/UserRole";
import * as permissions from '../../lib/permissions'
import ProjectInvoicing from "./reports/ProjectInvoicing";
import SystemSettings from './system_settings/SystemSettings'
import FirstLoginChangePassword from './auth/FirstLoginChangePassword'
import UserExpenses from "./users/UserExpenses";
import ProjectExpenseTypes from './project_expense_types/ProjectExpenseTypes'
import Notifications from './notifications/NotificationsContainer'
import AnnualLeave from './annual_leave/AnnualLeave'
import AnnualLeaveReport from './reports/AnnualLeaveReport'

class Main extends Component{

    render(){
        return (
            <div>
                <Navigation/>
                <AuthRoute path="/dashboard" exact component={Dashboard} />
                <AuthRoute path="/expenses" exact component={UserExpenses} />
                <AuthRoute path="/notifications" exact component={Notifications} />
                <AuthRoute path="/annual_leave" exact component={AnnualLeave} />
                <AuthRoute path="/first_login" exact component={FirstLoginChangePassword}/>
                <AuthRoute path="/permission_denied" exact component={PermissionDenied} />
                <AuthRoute path="/system_settings" exact component={SystemSettings}/>
                <AuthRoute
                    path="/projects/:project_id"
                    component={Project}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECTS,
                            permissions.CAN_EDIT_PROJECTS
                        ]
                    }
                />
                <AuthRoute
                    path="/projects"
                    exact
                    component={Projects}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECTS,
                        ]
                    }
                />
                <AuthRoute
                    path="/timesheet/:week_commencing?"
                    component={Timesheet}
                    permissions={
                        [
                            permissions.TIMESHEETS_CAN_ENTER_TIMESHEETS
                        ]
                    }
                />
                <AuthRoute
                    path="/clients/"
                    exact
                    component={Clients}
                    permissions={
                        [
                            permissions.CAN_VIEW_CLIENTS
                        ]
                    }
                />
                <AuthRoute
                    path="/clients/:client_id"
                    component={Client}
                    permissions={
                        [
                            permissions.CAN_VIEW_CLIENTS,
                            permissions.CAN_EDIT_CLIENTS
                        ]
                    }
                />
                <AuthRoute
                    path="/users/"
                    exact
                    component={Users}
                    permissions={
                        [
                            permissions.CAN_VIEW_USERS
                        ]
                    }
                />
                <AuthRoute
                    path="/users/create/"
                    exact
                    component={CreateUser}
                    permissions={
                        [
                            permissions.CAN_CREATE_USERS
                        ]
                    }
                />
                <AuthRoute
                    path="/users/:user_id(\d+)"
                    component={User}
                    permissions={
                        [
                            permissions.CAN_VIEW_USERS,
                            permissions.CAN_EDIT_USERS
                        ]
                    }
                />
                <AuthRoute
                    path="/reports/fee_drawdown"
                    exact
                    component={FeeDrawdownTable}
                    permissions={
                        [
                            permissions.REPORTS_CAN_VIEW_FEE_DRAWDOWN
                        ]
                    }
                />
                <AuthRoute
                    path="/reports/fee_drawdown/:project_id"
                    component={FeeDrawdownProjectDetail}
                    permissions={
                        [
                            permissions.REPORTS_CAN_VIEW_FEE_DRAWDOWN
                        ]
                    }
                />
                <AuthRoute
                    path="/reports/hours_worked/:office_id?/:month?/:year?"
                    component={OfficeHoursReport}
                />
                <AuthRoute
                    path="/reports/annual_leave/:year?"
                    component={AnnualLeaveReport}
                />
                <AuthRoute
                    path="/reports/projects/"
                    exact
                    component={ProjectsTable}
                    permissions={
                        [
                            permissions.REPORTS_CAN_VIEW_PROJECTS
                        ]
                    }
                />
                <AuthRoute
                    path="/reports/projects/:project_id"
                    component={ProjectAnalyticsContainer}
                    permissions={
                        [
                            permissions.REPORTS_CAN_VIEW_PROJECTS
                        ]
                    }
                />
                <AuthRoute
                    path="/reports/project_invoicing"
                    component={ProjectInvoicing}
                    permissions={
                        [
                            permissions.REPORTS_INVOICING
                        ]
                    }
                />
                <AuthRoute
                    path="/address_types/"
                    exact
                    component={AddressTypes}
                    permissions={
                        [
                            permissions.MISC_CAN_VIEW_ADDRESS_TYPES
                        ]
                    }
                />
                <AuthRoute
                    path="/project_expense_types/"
                    exact
                    component={ProjectExpenseTypes}
                    permissions={
                        [
                            permissions.MISC_CAN_VIEW_PROJECT_EXPENSE_TYPES
                        ]
                    }
                />
                <AuthRoute
                    path="/user_roles/"
                    exact
                    component={UserRolesNew}
                    permissions={
                        [
                            permissions.CAN_VIEW_USER_ROLES
                        ]
                    }
                />
                <AuthRoute
                    path="/user_roles/:user_role_id(\d+)"
                    exact
                    component={UserRole}
                    permissions={
                        [
                            permissions.CAN_VIEW_USER_ROLES,
                            permissions.CAN_EDIT_USER_ROLES
                        ]
                    }
                />
                <AuthRoute
                    path="/client_types/"
                    exact
                    component={ClientTypes}
                    permissions={
                        [
                            permissions.CAN_VIEW_CLIENT_TYPES,
                        ]
                    }
                />
                <AuthRoute
                    path="/project_activities/"
                    exact
                    component={ProjectActivities}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECT_ACTIVITIES,
                        ]
                    }
                />
                <AuthRoute
                    path="/project_disciplines/"
                    exact
                    component={ProjectDisciplines}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECT_DISCIPLINES,
                        ]
                    }
                />
                <AuthRoute
                    path="/project_statuses/"
                    exact
                    component={ProjectStatuses}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECT_STATUSES,
                        ]
                    }
                />
                <AuthRoute
                    path="/project_contract_statuses/"
                    exact
                    component={ProjectContractStatuses}
                />
                <AuthRoute
                    path="/project_fee_types/"
                    exact
                    component={ProjectFeeTypes}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECT_FEE_TYPES,
                        ]
                    }
                />
                <AuthRoute
                    path="/project_land_uses/"
                    exact
                    component={ProjectLandUses}
                    permissions={
                        [
                            permissions.CAN_VIEW_PROJECT_LAND_USES,
                        ]
                    }
                />
                <AuthRoute
                    path="/unbillable_types/"
                    exact
                    component={UnbillableTypes}
                    permissions={
                        [
                            permissions.TIMESHEETS_CAN_VIEW_UNBILLABLE_TYPES,
                        ]
                    }
                />
                <AuthRoute
                    path="/contact_mediums/"
                    exact
                    component={ContactMediums}
                    permissions={
                        [
                            permissions.MISC_CAN_VIEW_CONTACT_MEDIUMS,
                        ]
                    }
                />
                <AuthRoute
                    path="/staff_resource/"
                    exact
                    component={StaffResource}
                />
            </div>
        )

    }

}

export default Main